/**
 * Remote Flash
 * This service allows users to flash a telematics device over the air (FOTA) and retrieve the reported firmware information. 
 *
 * OpenAPI spec version: 0.1.5
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * The state of the device to receive new firmware. If the device has no desired firmware, then the default value will be 'Ready to Flash'. 
 */
export type State = 'Ready to Flash' | 'In Progress' | 'Pending Reboot' | 'Pending Download' | 'Downloaded';

export const State = {
    ReadyToFlash: 'Ready to Flash' as State,
    InProgress: 'In Progress' as State,
    PendingReboot: 'Pending Reboot' as State,
    PendingDownload: 'Pending Download' as State,
    Downloaded: 'Downloaded' as State
};